module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_Wood_MockedUp.ef3bf4d1.jpg";